export default {
  CURRENT_WEIGHT: 'weight now',
  TIME_PERIOD: 'time period',
  STARTING_WEIGHT: 'starting weight',
  HEIGHT: 'height',
};
